import React, { useState } from 'react'
import ConfirmationStage from './components/ConfirmationStage'
import { ErrorBox } from '../ErrorBox/ErrorBox'
import ResearchCall from './components/ResearchCall'
import PauseSubscription from './components/PauseSubscription'
import InitialStage from './components/InitialStage'

const STAGE_PAUSE = 'PAUSE'
const STAGE_RESEARCH = 'RESEARCH_CALL'
const STAGE_INITIAL = 'INITIAL'

const Cancel = ({
  onHide,
  sites,
  onUpgrade,
  currentPlanId,
  isStripeCustomer,
  nextBillingDate,
  currency,
  customerId,
  cardType,
  visitorCount
}) => {
  const [hasError, setHasError] = useState(false)
  const [stage, setStage] = useState(STAGE_INITIAL)

  if (hasError) {
    return <ErrorBox onClick={() => setHasError(false)} />
  }

  if (stage === STAGE_INITIAL) {
    return (
      <InitialStage
        visitorCount={visitorCount}
        onHide={onHide}
        onContinueToCancellation={() => setStage(isStripeCustomer ? STAGE_PAUSE : 'cancellation')}
        currentPlanId={currentPlanId}
      />
    )
  }

  if (stage === STAGE_PAUSE) {
    // Only for Stripe customers
    return (
      <PauseSubscription onHide={onHide} onCancel={() => setStage('cancellation')} nextBillingDate={nextBillingDate} />
    )
  } else if (stage === STAGE_RESEARCH) {
    return <ResearchCall onHide={onHide} />
  }

  return (
    <ConfirmationStage
      sites={sites}
      onUpgrade={onUpgrade}
      onBack={onHide}
      onHide={onHide}
      setHasError={setHasError}
      onBookUserResearchCall={() => setStage(STAGE_RESEARCH)}
      currentPlanId={currentPlanId}
      nextBillingDate={nextBillingDate}
      currency={currency}
      customerId={customerId}
      cardType={cardType}
    />
  )
}

export default Cancel
